// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3507":"6bffb435","6745":"cf5cd504"}[chunkId] + ".chunk.css";
};